import { memo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, ZoomControl } from 'react-leaflet';

import Leaflet, { LatLng } from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';
import './leaflet.css';

import { connectionStatus, mapPopupLabel } from '../../const/currentCarPlacePageConst';
import { CurrentCarPlaceInfoType } from '../../feature/type/CurrentCarPlaceInfoType';
import theme from '../../../theme';

const customIcon = (status: string) => {
	let className: string;
	switch (status) {
		case connectionStatus.connected:
			className = 'connected-icon';
			break;
		case connectionStatus.disconnected:
			className = 'disconnected-icon';
			break;
		default:
			className = 'default-icon';
	}

	return Leaflet.icon({
		iconUrl: icon,
		shadowUrl: iconShadow,
		className: className,
	});
};

type LeafletProp = {
	currentCarPlaceInfoList: CurrentCarPlaceInfoType[];
	centeredCurrentCarPlaceInfo: CurrentCarPlaceInfoType | undefined;
};

type ChangeMapCenterProp = {
	mapCenter: LatLng;
};

// 地図のデフォルト表示位置
const defaultMapCenter = new LatLng(35.681, 139.767);

const mapAttribution = '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors';
const mapUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

/**
 * マップの中央位置を変更する
 */
const ChangeMapCenter = (props: ChangeMapCenterProp) => {
	const map = useMap();
	map.panTo(props.mapCenter);
	return null;
};

/**
 * 現在車両一覧地図
 */
const CurrentCarPlaceMap = (props: LeafletProp) => {
	const { currentCarPlaceInfoList, centeredCurrentCarPlaceInfo } = props;
	const currentCarPlaceInfoListWithLatLon = currentCarPlaceInfoList.map((item) => {
		return {
			...item,
			latLon: new LatLng(item.lat, item.lon),
		};
	});

	const mapCenter =
		centeredCurrentCarPlaceInfo && centeredCurrentCarPlaceInfo.lat !== 0 && centeredCurrentCarPlaceInfo.lon !== 0
			? new LatLng(centeredCurrentCarPlaceInfo.lat, centeredCurrentCarPlaceInfo.lon)
			: defaultMapCenter;

	return (
		<div className="currentCarPlaceMap">
			<MapContainer center={defaultMapCenter} zoom={13} zoomControl={false} maxZoom={17} minZoom={5}>
				<TileLayer attribution={mapAttribution} url={mapUrl} />
				<ZoomControl position="topright" />
				{currentCarPlaceInfoListWithLatLon.map(
					(item, index) =>
						item.lat !== 0 &&
						item.lon !== 0 && (
							<Marker position={item.latLon} icon={customIcon(item.connectionStatus)} key={index}>
								<Popup autoPan={false}>
									<span style={{ color: theme.palette.primary.dark, fontSize: theme.typography.h1.fontSize }}>
										<b>{item.carCode}</b>
									</span>{' '}
									<br />
									<b>{mapPopupLabel.organization}</b> {item.organizationName} <br />
									<b>{mapPopupLabel.driver}</b> {item.driverName} <br />
								</Popup>
							</Marker>
						),
				)}
				{mapCenter && <ChangeMapCenter mapCenter={mapCenter} />}
			</MapContainer>
		</div>
	);
};

export default memo(CurrentCarPlaceMap);
